import { Settings } from './types';

export const APP_SETTINGS: Settings = {
  layout: 'admin',
  container: 'fixed',
  layouts: {
    admin: {
      sidebarCollapse: false,
      sidebarTheme: 'light',
    },
    demo1: {
      sidebarCollapse: false,
      sidebarTheme: 'light',
    },
    demo2: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo5: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo7: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo9: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
  },
};
